import type { SupplyAppsReference } from './model';

export function toSupplyAppsOptions(items: SupplyAppsReference[]) {
  return items.map((item) => ({ id: item.id, label: item.name }));
}
